var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{'u-border-b u-border-dark-2': _vm.faqItems.length}},_vm._l((_vm.faqItems),function(faqItem,index){return _c(_setup.FaqItem,{key:`faq-item-${index}`,staticClass:"faq-item",attrs:{"item":faqItem}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }